import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import { useRoute, useEmit } from '#app'
import { downloadCSV, downloadZip } from '~/functions/export'

import type { ExportKfwQuery } from '~/types/types'
import {
  FileFormat,
  useExportKfwLazyQuery,
  useListFundsQuery,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'KfwExport',
  props: {
  isPortfolioExport: { type: Boolean, default: false },
},
  emits: ['finish'],
  setup(__props, { emit }) {

const props = __props;





const route = useRoute()
const { result, loading: listFundsLoading } = useListFundsQuery()
const funds = computed(() => result.value?.listFunds || [])

const periods = [
  '2020',
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
  '2026',
  '2027',
  '2028',
  '2029',
  '2030',
]
const lastYear = (new Date().getFullYear() - 1).toString()

const initialInput = {
  period: lastYear,
  exportGp: false,
  exportFundIds: [],
  exportCompanyIds: route?.params?.venture ? [route?.params.venture] : [],
}

const input = ref({ ...initialInput })
const {
  load,
  loading: exportKfwLoading,
  refetch,
} = useExportKfwLazyQuery({
  input: input.value,
  fetchPolicy: 'network-only',
})

// keep input in sync with watcher as query composable doesn't refetch on deep input changes
watch(input, (v) => {
  // potential additional logic here if side effects needed in the future
})

const wait = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })

async function downloadAndFinish(
  data: ExportKfwQuery,
  toggleDialogCallback: () => void,
) {
  const zipFile = data?.exportKfw?.zipFile
  if (zipFile && zipFile.format === FileFormat.Zip) {
    downloadZip(zipFile.base64String, zipFile.fileName)
    toggleDialogCallback()
    emit('finish')
    input.value = { ...initialInput }
    return
  }

  const files = data?.exportKfw.files

  for (const file of files || []) {
    if (file && file.format === FileFormat.Csv) {
      downloadCSV(file.base64String, file.fileName)
      // Stagger browser download events to avoid browser throttling caps.
      await wait(100)
    }
  }

  toggleDialogCallback()
  emit('finish')
  input.value = { ...initialInput }
}

function triggerExport(toggleDialogCallback: () => void) {
  const loadResult = load(null, {
    input: input.value,
  })
  if (loadResult instanceof Promise) {
    loadResult.then((res) => downloadAndFinish(res, toggleDialogCallback))
  } else if (loadResult === false) {
    refetch({
      input: input.value,
    })?.then((res) => downloadAndFinish(res?.data, toggleDialogCallback))
  }
}

return { __sfc: true,props, emit, route, result, listFundsLoading, funds, periods, lastYear, initialInput, input, load, exportKfwLoading, refetch, wait, downloadAndFinish, triggerExport }
}

})